import React from 'react';
import ReactDOM from 'react-dom';
import RehydrateProvider from './components/RehydrateProvider';

ReactDOM.render(<RehydrateProvider />, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/